/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { ISupportsDataChangeNotifications_$type } from "./ISupportsDataChangeNotifications";
import { Type } from "./type";
/**
 * @hidden
 */
export var IDataSourceDataProviderUpdateNotifier_$type = /*@__PURE__*/ new Type(null, 'IDataSourceDataProviderUpdateNotifier', null, [ISupportsDataChangeNotifications_$type]);
//# sourceMappingURL=IDataSourceDataProviderUpdateNotifier.js.map
